import { render } from "./LocationForm.vue?vue&type=template&id=a6503850"
import script from "./LocationForm.vue?vue&type=script&lang=ts"
export * from "./LocationForm.vue?vue&type=script&lang=ts"
script.render = render

export default script